<template>
  <div>
    <v-container class="pl-0 mt-10 pt-0">
      <v-row no-gutters class="col-12 pl-0 pb-0">
        <input type="hidden" id="imageUploadCheck" value />
        <!--
          인쇄 템플릿 타입 1 start
        -->
        <v-col
          class="ml-3"
          v-model="printingTemplateType1"
          v-if="printingTemplateType1"
          style="margin-right:10px; width:260px;min-width: 260px;max-width: 260px;"
        >
          <v-row
            align="center"
            style="width:260px; min-width: 260px;max-width: 260px;"
          >
            <v-card
              outlined
              tile
              class="pl-10 pr-10 pt-10 pb-10 grey lighten-2"
              style="width:260px;min-width: 260px;max-width: 260px;"
            >
              <v-row class="white pl-2" style="width:203px;">
                <div>
                  <qrcode-vue
                    :value="QrCodeValue"
                    :size="QrCodeSize"
                    level="H"
                    class="mt-3 ml-0 mb-0"
                  ></qrcode-vue>
                </div>
                <div class="pt-0 pb-0 mt-3 pl-0 pr-0 pr-2" height="50px">
                  <div class="pt-0 pb-0 pl-2">
                    <p class="headline font-weight-black mb-0">正品</p>
                  </div>
                  <div class="pt-0 pb-0 pl-2 pr-2">
                    <p class="caption font-weight-black mb-0">
                      Genuine Royalty
                    </p>
                  </div>
                  <div class="pt-0 pb-0 pl-2 pr-2">
                    <p class="caption mb-0">Serial Number</p>
                  </div>
                </div>
              </v-row>
              <v-row class="white" style="width:203px;">
                <div class="pt-0 pb-0 ml-3">
                  <font class="caption font-weight-black"
                    >정품을 인증합니다</font
                  >
                </div>
              </v-row>
              <v-row class="white" style="width:203px;">
                <div class="pt-0 pb-0 ml-3">
                  <font
                    class="caption font-weight-black white--text pl-2 pr-2"
                    style="background-color: black"
                    >P201-7A73-00A0-1982</font
                  >
                </div>
              </v-row>
              <v-row class="white" style="width:203px;">
                <div
                  v-if="imageTemplate"
                  class="pt-0 pb-0"
                  v-html="imageTemplate"
                ></div>
                <div v-else class="pt-0 pb-0 ml-3 textArea">
                  <font class="caption font-weight-black text-center">{{
                    description ? description : "QR 코드를 스캔해주세요"
                  }}</font>
                </div>
              </v-row>
            </v-card>
          </v-row>
        </v-col>
        <!--
          인쇄 템플릿 타입 1 end
        -->
        <!--
          인쇄 템플릿 타입 2 start
        -->
        <v-col
          class="ml-3"
          align="cneter"
          v-model="printingTemplateType2"
          v-if="printingTemplateType2"
          style="margin-right:10px; width:260px;min-width: 260px;max-width: 260px;"
        >
          <v-row align="center">
            <v-card
              outlined
              tile
              class="pl-10 pr-10 pt-10 pb-10 grey lighten-2"
              style="width:260px;min-width: 260px;max-width: 260px;"
            >
              <v-row class="white" style="width:203px;">
                <div class="pt-0 pb-0 ml-0 col text-center">
                  <font class="caption font-weight-black text-center"
                    >[정품인증코드]</font
                  >
                </div>
              </v-row>

              <v-row class="white" style="width:203px;">
                <div class="pt-0 pb-0 ml-0 col text-center">
                  <font class="caption font-weight-black text-center"
                    >P201-7A73-00A0-1982</font
                  >
                </div>
              </v-row>

              <v-row class="white pl-6" style="width:203px;">
                <div class="pt-0 pb-0 mt-2 pl-0 pr-2" height="50px">
                  <div class="pt-0 pb-0 pl-2">
                    <p class="headline font-weight-black mb-0 text-center">
                      正品
                    </p>
                  </div>
                  <div class="pt-0 pb-0 pl-2">
                    <p class="caption mb-0 text-center">정품을</p>
                  </div>
                  <div class="pt-0 pb-0 pl-2">
                    <p class="caption mb-0 text-center">인증합니다</p>
                  </div>
                </div>
                <div>
                  <qrcode-vue
                    :value="QrCodeValue"
                    :size="QrCodeSize"
                    level="H"
                    class="mt-3 ml-0 mb-0"
                  ></qrcode-vue>
                </div>
              </v-row>
              <v-row class="white" style="width:203px;">
                <div
                  v-if="imageTemplate"
                  class="pt-0 pb-0"
                  v-html="imageTemplate"
                ></div>
                <div v-else class="pt-0 pb-0 ml-3 textArea text-center">
                  <font class="caption font-weight-black text-center">{{
                    description ? description : "QR 코드를 스캔해주세요"
                  }}</font>
                </div>
              </v-row>
            </v-card>
          </v-row>
        </v-col>
        <!--
          인쇄 템플릿 타입 2 end.
        -->
        <v-col class="ml-10">
          <v-card outlined color="white">
            <v-row>
              <div
                class="pb-0 pt-6 font-weight-black pl-0 pr-0"
                style="width:100px; min-width:100px;"
              >
                인쇄 용지
              </div>
              <v-col
                class="pt-3 pb-0"
                height="50px"
                style="width:560px; min-width:560px; max-width:560px;"
              >
                <v-select
                  v-model="paper"
                  :items="printingPaperList"
                  item-text="text"
                  item-value="value"
                  persistent-hint
                  return-object
                  single-line
                  class="pt-0"
                  outlined
                  dense
                  @change="changePrintingPaper(paper.value)"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <div
                class="pb-0 pt-6 font-weight-black pl-0 pr-0"
                style="width:100px; min-width:100px;"
              >
                인쇄 템플릿
              </div>
              <v-col
                class="pt-3 pb-0"
                height="50px"
                style="width:560px; min-width:560px; max-width:560px;"
              >
                <v-select
                  v-model="template"
                  :items="printingTemplateList"
                  item-text="text"
                  item-value="value"
                  persistent-hint
                  return-object
                  single-line
                  class="pt-0"
                  @change="changePrintingTemplate(template.value)"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                class="pb-0 pt-6 font-weight-black pl-0"
                style="width:100px; min-width:100px; max-width:100px;"
                >하단 옵션</v-col
              >
              <v-col class="pt-3 pb-0 pl-0">
                <v-radio-group
                  v-model="radios"
                  class="mt-0 ml-2"
                  @change="changePrintingOptionRadio"
                >
                  <div class="pl-0 pb-0 pt-0">
                    <div
                      class="d-inline-block pl-0 pb-0 pr-0"
                      style="width:150px; min-width:150px; max-width:150px;"
                    >
                      <v-radio
                        label="사용안함"
                        value="사용안함"
                        height="50"
                        name="optionRadio"
                      ></v-radio>
                    </div>
                    <v-col
                      class="d-inline-block pl-0 pb-0 pt-0 verticalAlignTextBottom"
                      style="width:400px; min-width:400px; max-width:400px;"
                    >
                      <v-card
                        outlined
                        dense
                        disabled
                        class="body-2 white"
                        height="40"
                      >
                        <v-card-text class="pl-0">
                          <p class="mb-0 pb-0">
                            * 기본 문구 노출됩니다 - QR 코드를 스캔해주세요
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </div>

                  <v-col class="pl-0 pt-0 pb-0 pt-3">
                    <v-col
                      class="d-inline-block pl-0 pr-0"
                      style="width:150px; min-width:150px; max-width:150px;"
                    >
                      <v-radio
                        label="이미지 삽입"
                        value="이미지 삽입"
                        name="optionRadio"
                      ></v-radio>
                    </v-col>
                    <v-col
                      class="d-inline-block pl-0 pb-0 pr-0 mr-0"
                      style="width:290px; min-width:290px; max-width:290px;"
                    >
                      <v-file-input
                        flat
                        dense
                        placeholder="클릭해주세요 (203x35 등록 가능)"
                        class="body-2"
                        :disabled="radios !== '이미지 삽입'"
                        v-model="file"
                        id="uploadImg"
                        :onchange="uploadImgfile()"
                      ></v-file-input>
                    </v-col>
                    <v-col
                      class="d-inline-block ml-0 pl-0 pr-0"
                      style="width:100px; min-width:100px; max-width:100px;"
                    >
                      <v-btn
                        color="black"
                        class="white--text font-weight-bold"
                        :disabled="radios !== '이미지 삽입'"
                        @click="imageUpload"
                        style="width:80px; min-width:80px; max-width:80px;margin-left: 20px;"
                        >업로드</v-btn
                      >
                    </v-col>
                  </v-col>
                  <v-col class="pl-0 pt-0 pb-0 pr-0">
                    <v-col
                      cols="3"
                      class="d-inline-block pl-0"
                      style="width:150px; min-width:150px; max-width:150px;"
                    >
                      <v-radio label="문구 삽입" value="문구 삽입"></v-radio>
                    </v-col>
                    <v-col
                      class="d-inline-block ml-0 pl-0 pt-0 pr-0"
                      style="width:390px; min-width:390px; max-width:390px;"
                    >
                      <v-text-field
                        label="최대 14자까지 입력"
                        outlined
                        dense
                        :disabled="radios !== '문구 삽입'"
                        v-model="description"
                        maxlength="14"
                        v-on:keyup="descriptionLengCheck"
                      ></v-text-field>
                    </v-col>
                  </v-col>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div align="center" class="col-7">
            <v-btn
              class="green white--text font-weight-bold mt-10 mr-5"
              width="250"
              @click="printSettingDescription"
              large
              >라벨프린터 인쇄 설정 (필독)</v-btn
            >
            <v-btn
              class="blue darken-1 white--text font-weight-bold mt-10"
              width="200"
              @click.prevent="saveQrcodeSettingInfo"
              large
              >저장</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.verticalAlignTextBottom {
  vertical-align: text-bottom;
}

.textArea {
  width: 174px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
}
</style>

<script>
import M from "@/libs/mapping.js";
import QrcodeVue from "qrcode.vue";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      file: [],
      radios: "사용안함",
      QrCodeValue: "https://example.com",
      QrCodeSize: 70,
      printingPaperList: [
        {
          text: "선택해주세요.",
          value: "선택해주세요.",
        },
        {
          text: "60*48mm a4 라벨지 (일반프린터)",
          value: "a4",
        },
        {
          text: "60*48mm 롤 라벨지 (라벨프린터)",
          value: "rolLabel",
        },
      ],
      paper: "a4",
      printingTemplateList: [
        {
          text: "타입1",
          value: "type1",
        },
        {
          text: "타입2",
          value: "type2",
        },
      ],
      template: "type2",
      printingTemplateType1: true,
      printingTemplateType2: false,
      imageDisabled: false,
      description: "",
      image_url: localStorage.imageUrlInfo,
      imageTemplate: "",
      imageSizeCheckResult: "",
    };
  },
  created: async function() {
    /**
     * 데이터 가져오기
     */
    await this.getQrcodeSettingInfo();
  },
  mixins: [CommonMixin],
  methods: {
    setImageSizeCheckResult: function(v) {
      this.imageSizeCheckResult = v;
    },
    /**
     * 이미지 사이즈 체크
     */
    uploadImgfile: function() {
      let _URL = window.URL || window.webkitURL;
      let file;
      let uploadImg = document.getElementById("uploadImg");

      if (uploadImg) {
        let imageFile = document.getElementById("uploadImg").files[0];
        if ((file = imageFile)) {
          let img = new Image();
          var objectUrl = _URL.createObjectURL(file);
          img.onload = function() {
            if (img.width == 203 && img.height == 35) {
              document.getElementById("imageUploadCheck").value = "Y";
            } else {
              alert("넓이 203px, 높이 35px으로 맞춰주세요.");
              document.getElementById("imageUploadCheck").value = "N";
            }

            _URL.revokeObjectURL(objectUrl);
          };
          img.src = objectUrl;
        }
      }
    },
    /**
     * 인쇄 용지
     */
    changePrintingPaper: function(value) {
      this.paper = value;
    },

    /**
     * 인쇄 템플릿
     */
    changePrintingTemplate: function(value) {
      this.template = value;
      if (value == "type1") {
        this.printingTemplateType1 = true;
        this.printingTemplateType2 = false;
      } else {
        this.printingTemplateType1 = false;
        this.printingTemplateType2 = true;
      }
    },

    /**
     * 하단옵션
     */
    changePrintingOptionRadio: function() {
      if (this.radios == "사용안함") {
        this.description = "";
        this.image_url = "";
        this.imageTemplate = "";
      }
      if (this.radios == "이미지 삽입") {
        this.description = "";
        if (localStorage.imageUrlInfo) {
          this.imageTemplate = "<img src=" + localStorage.imageUrlInfo + ">";
        } else {
          this.imageTemplate =
            "<font class='caption font-weight-black text-center'>QR 코드를 스캔해주세요</font>";
        }
      }
      if (this.radios == "문구 삽입") {
        //
        this.image_url = "";
        this.imageTemplate = "";
      }
    },

    /**
     * QR 코드 인쇄 설정 정보 설정 하기
     */
    setQrcodeSettingInfo: function(data) {
      this.paper = "선택해주세요.";
      this.template = "type2";
      this.radios = "사용안함";

      //인쇄 용지 선택
      if (data.print_paper) {
        this.paper = data.print_paper;
      }

      // 인쇄 템플릿 선택
      if (data.print_paper) {
        this.template = data.print_template;
        this.changePrintingTemplate(data.print_template);
      }

      // 하단 옵션 이미지 삽입 선택
      if (localStorage.imageUrlInfo) {
        this.radios = "이미지 삽입";
        this.image_url = localStorage.imageUrlInfo;
      }

      // 하단 옵션 문구 삽입 선택
      if (data.print_description) {
        this.radios = "문구 삽입";
        this.description = data.print_description;
      }

      this.changePrintingOptionRadio();
    },

    imageUpload: async function() {
      let imageUploadCheck = document.getElementById("imageUploadCheck").value;
      if (imageUploadCheck == "N") {
        alert("이미지를 확인해주세요.");
        return false;
      }
      let formData = new FormData();
      formData.append("images", this.file, this.file.name);

      let data = await M.api(M.entry("/post/print"), formData);

      if (data.print_image_url) {
        localStorage.imageUrlInfo = data.print_image_url;
        this.imageTemplate = "<img src=" + data.print_image_url + ">";
      } else {
        this.imageTemplate =
          "<font class='caption font-weight-black text-center'>QR 코드를 스캔해주세요</font>";
      }
    },

    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {
      try {
        let data = await M.api(M.entry("/get/print"), {});
        if (data) {
          if (data.print_paper == "60*48mm a4 라벨지 (일반프린터)") {
            data.print_paper = "선택해주세요.";
          }
          if (data.print_template == "타입1") {
            data.print_template = "type2";
          }

          if (localStorage.imageUrlInfo) {
            data.print_image_url = localStorage.imageUrlInfo;
          }
          this.setQrcodeSettingInfo(data);
        }
      } catch {
        this.paper = "선택해주세요.";
        this.template = "type2";
        this.radios = "사용안함";
      }
    },

    /**
     * QR 코드 인쇄 설정 정보 저장
     */
    saveQrcodeSettingInfo: async function() {
      if (this.description.length > "14") {
        this.alertShow("14자 이상입니다");
        return false;
      }

      if (this.radios == "이미지 삽입") {
        this.description = "";
      } else if (this.radios == "문구 삽입") {
        localStorage.imageUrlInfo = "";
      } else {
        localStorage.imageUrlInfo = "";
        this.description = "";
      }

      if (this.paper == "선택해주세요.") {
        this.alertShow("인쇄 용지를 선택해주세요.");
        return false;
      }

      if (!this.template) {
        this.alertShow("인쇄 템플릿을 선택해주세요.");
        return false;
      }

      //전송 파라메터
      let putParams = {
        template: this.template,
        paper: this.paper,
        image_url: this.image_url,
        description: this.description,
      };

      let data = await M.api(M.entry("/put/print"), putParams);
      if (data) {
        this.alertShow("저장되었습니다.");
      }
    },
    printSettingDescription: function() {
      window.open(
        "https://docs.google.com/presentation/d/1dn_b7Q0s1SJ0iyTY_Wc9wwnS2zRwe19GDUmXnTIkw4Y/edit?usp=sharing",
        "printSettingDescription"
      );
    },
    descriptionLengCheck: function() {
      if (this.description.length >= 14) {
        return false;
      }
    },
  },
  components: {
    QrcodeVue,
  },
};
</script>
